import DateFilter from '../framework/filters/DateFilter'
import AccountUtil from './AccountUtil'
import BasicModel from '@/framework/basic/BasicModel'
import lrz from 'lrz'
export default {
  mixins: [ DateFilter, AccountUtil ],
  data: function () {
    return {
      loginInfo: {}
    }
  },
  created: function () {
    let loginInfo = this.getLoginInfo()
    if (loginInfo) {
      this.loginInfo = loginInfo
    }
  },
  methods: {
    onHttpRequest: function (e) {
      let _this = this

      // 文件图片压缩图片
      if (e.file.type.indexOf('image') > -1 && e.file.size > 1048576 * 3) {
        lrz(e.file, {
          quality: 0.3
        }).then(function (rst) {
          console.log('原图' + (e.file.size / 1024) + 'kb============>压缩后：' + (rst.file.size / 1024) + 'kb')
          _this.uploadFile(rst.file, e.data.floder, e.onSuccess, e.action)
          return rst
        })
      } else {
        console.log('============>不压缩')
        _this.uploadFile(e.file, e.data.floder, e.onSuccess, e.action)
      }
    },

    uploadFile: function (file, floder, callback, action) {
      let formData = new FormData()
      formData.append('file', file)
      formData.append('floder', floder)

      let listener = {
        success: function (dataInfo) {
          callback(dataInfo)
        }
      }

      BasicModel.post(this, action, formData, listener)
    },
    resetFrom: function (formName) {
      this.$refs[formName].resetFields()
    },
    refreshList: function () {
      this.$refs['list-template'].loadList()
    },
    validateFrom: function (formName, handleSubmit) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          handleSubmit()
        } else {
          return false
        }
      })
    }
  }
}
